import type { EnumUnion } from '@dresscode-frontend/utility-types';
export const ContractStatus = {
  DRAFT: 'DRAFT',
  PENDING_SIGNATURE: 'PENDING_SIGNATURE',
  REJECTED_SIGNATURE: 'REJECTED_SIGNATURE',
  EXECUTED: 'EXECUTED',
  WAITING: 'WAITING',
  TERMINATED: 'TERMINATED',
  CANCELLED: 'CANCELLED'
} as const;
export type ContractStatus = EnumUnion<typeof ContractStatus>;
const CONTRACT_STATUS_VALUES = new Set<string>(Object.values(ContractStatus));

/** 任意の文字列が ContractStatus かを判定する（BE の BadgeValue.code 等の絞り込み用） */
export function isContractStatus(value: string | undefined): value is ContractStatus {
  return value != null && CONTRACT_STATUS_VALUES.has(value);
}
export type ContractStatusI18nKey = 'contractStatus.DRAFT' | 'contractStatus.PENDING_SIGNATURE' | 'contractStatus.REJECTED_SIGNATURE' | 'contractStatus.EXECUTED' | 'contractStatus.WAITING' | 'contractStatus.TERMINATED' | 'contractStatus.CANCELLED';